module.exports = __webpack_public_path__ + "static/media/nl-NL.27174b05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard-languages/nl-NL.png
// module id = 952
// module chunks = 0